// Dynamic public path
// eslint-disable-next-line
__webpack_public_path__ = window.degewoblog.JS_BASE_URL || '/javascripts/';
